export default '/pricing/slot';
